export default {
  metric: ['Traffic'],
  aggregateTypes: ['p95th_bits_per_sec'],
  lookback_seconds: 86400,
  all_devices: true,
  show_overlay: false,
  show_total_overlay: true,
  viz_type: 'line',
  filterDimensionsEnabled: true,
  filterDimensionName: 'Total',
  filterDimensionOther: false,
  filterDimensionSort: true,
  filterDimensions: {
    connector: 'All',
    filterGroups: [
      {
        name: 'Ingress',
        named: true,
        connector: 'All',
        not: false,
        autoAdded: '',
        saved_filters: [],
        filterGroups: [],
        filters: []
      },
      {
        name: 'Egress',
        named: true,
        connector: 'All',
        not: false,
        autoAdded: '',
        saved_filters: [],
        filterGroups: [],
        filters: []
      }
    ]
  }
};
